const Area = () =>
  import(/* webpackChunkName: "site-generator-cms-area" */ '@/pages/site-generator/cms/area/index.vue')

const CreateArea = () =>
  import(
    /* webpackChunkName: "site-generator-cms-area" */ '@/pages/site-generator/cms/area/create.vue'
  )

const EditArea = () =>
  import(
    /* webpackChunkName: "site-generator-cms-area" */ '@/pages/site-generator/cms/area/edit.vue'
  )

export default {
  path: 'area',
  meta: {
    label: 'area',
    auth: 'area'
  },
  component: {
    name: 'Area',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SiteAreaReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Area
    },
    {
      name: 'SiteCreateArea',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateArea
    },
    {
      name: 'SiteEditArea',
      path: 'area/edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditArea,
      props: true
    }
  ]
}
